import axios from "axios";
import { getCurrentTenant } from "./tenantConfig";

const { apiBaseUrl: API_BASE_URL, API_USERS_HOST } = getCurrentTenant();

// Axios instance oluştur
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  testURL: API_USERS_HOST,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const projectCode = localStorage.getItem("projectCode");
    const authToken = localStorage.getItem("authToken");

    // Project code'u URL'e ekle
    if (projectCode && !config.url.includes(projectCode)) {
      config.url = `/${projectCode}${config.url}`;
    }

    // Auth token'ı header'a ekle
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }

    // Request'i logla (development için)
    if (process.env.NODE_ENV === "development") {
      console.log("🚀 Request:", config.method.toUpperCase(), config.url);
    }

    return config;
  },
  (error) => {
    console.error("❌ Request Error:", error);
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Response'u logla (development için)
    if (process.env.NODE_ENV === "development") {
      console.log("✅ Response:", response.config.url, response.status);
    }

    // API'niz returnCode kullanıyorsa, burada kontrol et
    if (response.data && response.data.returnCode !== undefined) {
      if (response.data.returnCode === 0) {
        // Başarılı yanıt - sadece data'yı döndür
        return response.data.data;
      } else {
        // API'den gelen hata
        const error = new Error(
          response.data.exMessage || "İşlem başarısız oldu"
        );
        error.returnCode = response.data.returnCode;
        error.response = response;
        throw error;
      }
    }

    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // 401 Unauthorized - Token süresi dolmuş
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Token yenileme isteği
        const refreshToken = localStorage.getItem("refreshToken");

        if (refreshToken) {
          const response = await axios.post(
            `${API_BASE_URL}/api/Auth/RefreshToken`,
            { refreshToken }
          );

          if (response.data.returnCode === 0) {
            const newToken = response.data.data.authToken;
            localStorage.setItem("authToken", newToken);

            // Orijinal isteği yeni token ile tekrarla
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return axiosInstance(originalRequest);
          }
        }

        // Token yenilenemezse, kullanıcıyı login sayfasına yönlendir
        localStorage.clear();
        window.location.href = "/login";
      } catch (refreshError) {
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    // 403 Forbidden - Yetki hatası
    if (error.response?.status === 403) {
      console.error("⛔ Yetkisiz erişim:", error.config.url);
      // İsteğe bağlı: Kullanıcıya bildirim göster
    }

    // 404 Not Found
    if (error.response?.status === 404) {
      console.error("🔍 Kaynak bulunamadı:", error.config.url);
    }

    // 500 Server Error
    if (error.response?.status >= 500) {
      console.error("🔥 Sunucu hatası:", error.response.status);
      // İsteğe bağlı: Kullanıcıya genel hata mesajı göster
    }

    // Network Error
    if (!error.response) {
      console.error("📡 Ağ hatası veya sunucuya erişilemiyor");
    }

    console.error("❌ Response Error:", error.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;
